import styled from 'styled-components'

const HighlightedSpan = styled.span`
  background-color: #FEF08A;
  color: #1F2937;
  border-radius: 2px;
  padding: 0 1px;
`

interface HighlightProps {
  html: string
}

export const Highlight = ({ html }: HighlightProps) => {
  const markRegex = /(<mark>.*?<\/mark>)/g
  const parts = html.split(markRegex)

  return (
    <>
      {parts.map((part, index) => {
        const match = part.match(/^<mark>(.*?)<\/mark>$/)
        if (match) {
          return <HighlightedSpan key={index}>{match[1]}</HighlightedSpan>
        }
        return <span key={index}>{part}</span>
      })}
    </>
  )
}
